
const config = "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600";

export default {
  name: 'ModalShare',

  props: {
    url: {type: String, required: true},
  },

  methods: {
    open() {
      this.$refs.modal.open();
    },

    twitter() {
      window.open(`https://twitter.com/intent/tweet?url=${this.url}`, '', config);
      this.$refs.modal.quit();
    },

    facebook() {
      // Check if the script already exists
      const existingScript = document.querySelector('script[src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v15.0"]');

      if (!existingScript) {
        // Create the script element
        const fbSdkScript = document.createElement('script');

        // Set the attributes for the script element
        fbSdkScript.async = true;
        fbSdkScript.defer = true;
        fbSdkScript.crossOrigin = 'anonymous';
        fbSdkScript.onload = () => {
          window.open(`https://www.facebook.com/sharer/sharer.php?u=${this.url}`, '', config);
          this.$refs.modal.quit();
        }
        fbSdkScript.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v15.0';
        // Append the script element to the document head
        document.head.appendChild(fbSdkScript);
      } else {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${this.url}`, '', config);
        this.$refs.modal.quit();
      }
    },

    telegram() {
      window.open(`https://telegram.me/share/url?url=${this.url}`, '', config);
      this.$refs.modal.quit();
    },

    email() {
      this.$refs.modal.quit();
    },

    clipboard() {
      navigator.clipboard.writeText(this.url);
      this.$refs.modal.quit();
    },
  }

}
